var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_filter",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_auto_class"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0.1)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_14",
    "data-name": "\\uD569\\uCE58\\uAE30 14",
    d: "M-15347.6-2841.123a6.745,6.745,0,0,1-4.1-3.271,7.261,7.261,0,0,1-.906-3.576l-.612.643a.579.579,0,0,1-.424.181.579.579,0,0,1-.424-.181.652.652,0,0,1,0-.886l1.784-1.865a.58.58,0,0,1,.844,0l1.614,1.692a.652.652,0,0,1,0,.886.58.58,0,0,1-.844,0l-.743-.778a6.029,6.029,0,0,0,.743,3.256,5.552,5.552,0,0,0,3.372,2.69,5.379,5.379,0,0,0,5.31-1.484.58.58,0,0,1,.844,0,.649.649,0,0,1-.007.886,6.6,6.6,0,0,1-4.744,2.035A6.493,6.493,0,0,1-15347.6-2841.123Zm7.522-4.462c-.016,0-.027-.016-.043-.019a.434.434,0,0,1-.111-.054.528.528,0,0,1-.1-.066c-.012-.011-.026-.015-.038-.031l-1.619-1.692a.649.649,0,0,1,0-.882.578.578,0,0,1,.848,0l.752.786c0-.12.016-.239.012-.358a5.643,5.643,0,0,0-5.5-5.753h-.02a5.351,5.351,0,0,0-3.872,1.688.58.58,0,0,1-.844,0,.652.652,0,0,1,0-.886,6.523,6.523,0,0,1,4.716-2.054h.02a6.869,6.869,0,0,1,6.7,6.994v.031l.428-.447a.574.574,0,0,1,.844,0,.647.647,0,0,1,0,.882l-1.614,1.692c-.008.011-.02.011-.027.019a.578.578,0,0,1-.127.089.451.451,0,0,1-.058.035.559.559,0,0,1-.212.042A.5.5,0,0,1-15340.081-2845.585Z",
    transform: "translate(15358.239 2859.907)",
    fill: "#2992ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterBlue);
export default __webpack_public_path__ + "static/media/icon_filter_blue.b710addd44845f419d006c884b5a7403.svg";
export { ForwardRef as ReactComponent };